export default __webpack_public_path__ + "static/media/Madagascar.4c40dc58.png";